"use client";

import { Button, Icon } from "@cloai/uikit";
import { useTranslations } from "next-intl";
import { FC } from "react";

/**
 * Пропсы для компонента навигации
 */
interface StorylineNavigationProps {
  /** Индекс активного слайда */
  active: number;
  /** Максимальное количество слайдов */
  limit: number;
  /** Обработчик для перехода назад */
  onBackAction: () => void;
  /** Обработчик для перехода вперед */
  onNextAction: () => void;
}

/**
 * Компонент навигации по слайдам сторилайна
 *
 * @description
 * Отображает кнопки навигации и индикаторы прогресса.
 * Автоматически меняет текст кнопки "Далее" на "Закрыть" на последнем слайде.
 *
 * @example
 * ```tsx
 * <StorylineNavigation
 *   active={0}
 *   limit={5}
 *   onBackAction={() => {}}
 *   onNextAction={() => {}}
 * />
 * ```
 */
export const StorylineNavigation: FC<StorylineNavigationProps> = ({
  active,
  limit,
  onBackAction,
  onNextAction,
}) => {
  const t = useTranslations("TutorModal");

  const isLastSlide = active === limit;

  return (
    <div className="flex w-full items-center gap-3">
      <Button
        startContent={<Icon icon="arrow_back" />}
        variant="ghost"
        wide
        onClick={onBackAction}
        disabled={!active}
        aria-label={t("back")}
      >
        {t("back")}
      </Button>

      <Button
        endContent={<Icon icon={isLastSlide ? "close" : "arrow_forward"} />}
        color="primary"
        wide
        onClick={onNextAction}
        aria-label={isLastSlide ? t("close") : t("next")}
      >
        {isLastSlide ? t("close") : t("next")}
      </Button>
    </div>
  );
};
